/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/NotificationAPI'
], (APIFactory, NotificationAPI) => {

	class Notification {
		constructor(options) {
			this.dashboard = options.features['API'];
			this._api = APIFactory.createAPI(this, [NotificationAPI]);
		}

		getAPI() {
			return this._api;
		}

		setMessage(message) {
			this.dashboard.showToast(message);
		}

	}

	return Notification;
});
